import { TAB_NOTES, TAB_ARCHIVE } from '../utils/index.js';

class BottomNav extends HTMLElement {
  _boundHandlers = new Map();

  static observedAttributes = ['active-tab'];

  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this._attachEventListeners();
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  attributeChangedCallback() {
    this.render();
    this._attachEventListeners();
  }

  get activeTab() {
    return this.getAttribute('active-tab') || TAB_NOTES;
  }

  set activeTab(value) {
    this.setAttribute('active-tab', value);
  }

  _removeEventListeners() {
    this._boundHandlers.forEach((handler, element) => {
      element.removeEventListener('click', handler);
    });
    this._boundHandlers.clear();
  }

  _attachEventListeners() {
    const tabs = this.querySelectorAll('.bottom-nav-btn[data-tab]');
    tabs.forEach((tab) => {
      const handler = () => {
        const tabValue = tab.dataset.tab;
        this.activeTab = tabValue;
        this.dispatchEvent(
          new CustomEvent('tab-changed', {
            detail: { tab: tabValue },
            bubbles: true,
          })
        );
      };
      tab.addEventListener('click', handler);
      this._boundHandlers.set(tab, handler);
    });

    // Add button handler
    const addBtn = this.querySelector('.bottom-nav-add-btn');
    if (addBtn) {
      const addHandler = () => {
        this.dispatchEvent(
          new CustomEvent('add-clicked', {
            bubbles: true,
          })
        );
      };
      addBtn.addEventListener('click', addHandler);
      this._boundHandlers.set(addBtn, addHandler);
    }
  }

  render() {
    this._removeEventListeners();

    const notesActive = this.activeTab === TAB_NOTES ? 'active' : '';
    const archiveActive = this.activeTab === TAB_ARCHIVE ? 'active' : '';
    const notesFilled = this.activeTab === TAB_NOTES ? 'filled' : '';

    this.innerHTML = `
      <nav class="bottom-nav-container" role="navigation" aria-label="Navigation">
        <button
          class="bottom-nav-btn ${notesActive}"
          data-tab="${TAB_NOTES}"
          role="tab"
          aria-selected="${this.activeTab === TAB_NOTES}"
          aria-label="All Notes"
        >
          <span class="material-symbols-outlined ${notesFilled}" aria-hidden="true">description</span>
          <span class="label">Notes</span>
        </button>
        <button
          class="bottom-nav-add-btn"
          aria-label="Create new note"
        >
          <div class="bottom-nav-add-btn-inner">
            <span class="material-symbols-outlined" aria-hidden="true">add</span>
          </div>
        </button>
        <button
          class="bottom-nav-btn ${archiveActive}"
          data-tab="${TAB_ARCHIVE}"
          role="tab"
          aria-selected="${this.activeTab === TAB_ARCHIVE}"
          aria-label="Archived Notes"
        >
          <span class="material-symbols-outlined" aria-hidden="true">archive</span>
          <span class="label">Archive</span>
        </button>
      </nav>
    `;
  }
}

customElements.define('bottom-nav', BottomNav);
